/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".banner-registration-wrap[_ngcontent-%COMP%]{background:linear-gradient(45deg,#5a616d,#8492a6);border:0 solid #000;border-radius:10px}.reg-top-title[_ngcontent-%COMP%]{letter-spacing:.1rem}.reg-date[_ngcontent-%COMP%]{background:#3e4551;display:inline-block;padding:.3rem}"];
export { styles as styles };
